<template>
	<div v-if="$checkPerm('process.cbt.create')">
		<form role="form" v-on:submit.prevent="createQuestions">
			<div class="cbt_question_group" v-for="(question, index) in cbtquestions">
				<div class="pull-right mt-3">
					<button type="button" class="btn btn-danger btn-sm" v-on:click="removeQuestion(index)">Remove Q{{index + 1}}</button>
				</div>

				<!-- THE FORM FIELDS TO BUILD EACH QUESTION TYPE -->

				<!-- QUESTION TYPE: SITUATIONAL JUDGEMENT -->
				<div v-if="question.questiontype == 'sj'" class="single_question">
					<div class="form-group">
						<h5 class="mb-2">Question {{index + 1}}: </h5>
						<textarea v-model="cbtquestions[index].questioncontent" placeholder="Question" class="form-control" required="required"></textarea>
					</div>
					<div class="form-group question_options">
						<label>Question Options:</label>
						<div class="row">
							<div class="col-lg-6 mt-2" v-for="(options, option_index) in question.options">
								<input type="text" v-model="cbtquestions[index].options[option_index]" class="form-control" v-bind:placeholder="'Option ' + (option_index + 1)"
								 required="required" />
							</div>
							<div class="col-lg-6">
								<button type="button" class="btn btn-inverse btn-outline-inverse btn-sm mt-2" v-on:click="removeFieldFromQuestion('options', index)"
								 v-if="question.options.length > 0">
									<i class="icofont icofont-minus"></i>
								</button>
								<button type="button" class="btn btn-inverse btn-outline-inverse btn-sm mt-2" v-on:click="addFieldToQuestion('options', index)">
									<i class="icofont icofont-plus"></i>
								</button>
							</div>
						</div>
					</div>
					<div class="form-group answer_tags mt-3">
						<label>Answer Tag(s):</label>
						<div class="row">
							<div class="col-lg-6 mt-2" v-for="(tag, tag_index) in question.answer_tags">
								<input type="text" v-model="cbtquestions[index].answer_tags[tag_index]" class="form-control" v-bind:placeholder="'Tag ' + (tag_index + 1) + ' e.g: Most Likely'" />
							</div>
							<div class="col-lg-6">
								<button type="button" class="btn btn-inverse btn-outline-inverse btn-sm mt-2" v-on:click="removeFieldFromQuestion('answer_tags', index)"
								 v-if="question.answer_tags.length > 0">
									<i class="icofont icofont-minus"></i>
								</button>
								<button type="button" class="btn btn-inverse btn-outline-inverse btn-sm mt-2" v-on:click="addFieldToQuestion('answer_tags', index)">
									<i class="icofont icofont-plus"></i>
								</button>
							</div>
						</div>
					</div>
					<div class="form-group answers mt-3" v-if="question.answer_tags.length > 0 && question.options.length">
						<!-- The answers should be equal to the number of answer tags -->
						<label>Answer(s):</label>
						<div class="row">
							<div class="col-lg-6 mt-2" v-for="(tag, t_index) in question.answer_tags">
								<h6>Answer to Tag {{t_index + 1}}</h6>
								<select class="form-control" v-model="cbtquestions[index].answers[t_index]" required="required">
									<option v-for="(options, o_index) in question.options" v-bind:value="o_index">{{options}}</option>
								</select>
							</div>
						</div>
					</div>
					<div class="form-group score mt-3">
						<label>Question Score:</label>
						<input type="number" class="form-control" v-model="cbtquestions[index].score" required="required" />
					</div>
				</div>
				<!-- END QUESTION TYPE SITUATIONAL JUDGEMENT -->

				<!-- QUESTION TYPE: SINGLE ANSWER -->
				<div v-else-if="question.questiontype == 'sa'" class="single_question">
					<div class="form-group">
						<h6 class="mb-2">Question {{index + 1}}: </h6>
						<textarea v-model="cbtquestions[index].questioncontent" placeholder="Question" class="form-control" required="required"></textarea>
					</div>
					<div class="form-group question_options">
						<label>Question Options:</label>
						<div class="row">
							<div class="col-lg-6 mt-2" v-for="(options, option_index) in question.options">
								<input type="text" v-model="cbtquestions[index].options[option_index]" class="form-control" v-bind:placeholder="'Option ' + (option_index + 1)"
								 required="required" />
							</div>
							<div class="col-lg-6">
								<button type="button" class="btn btn-inverse btn-outline-inverse btn-sm mt-2" v-on:click="removeFieldFromQuestion('options', index)"
								 v-if="question.options.length > 0">
									<i class="icofont icofont-minus"></i>
								</button>
								<button type="button" class="btn btn-inverse btn-outline-inverse btn-sm mt-2" v-on:click="addFieldToQuestion('options', index)">
									<i class="icofont icofont-plus"></i>
								</button>
							</div>
						</div>
					</div>
					<div class="form-group question_answer" v-if="cbtquestions[index].options.length > 1">
						<label>Correct Answer:</label>
						<div v-for="(options, o_index) in question.options">
							<input type="radio" v-bind:name="'question_option_' + index" v-bind:value="o_index" v-model="cbtquestions[index].answers[0]" />
							<span class="ml-2">{{cbtquestions[index].options[o_index]}}</span>
						</div>
					</div>
					<div class="form-group score mt-3">
						<label>Question Score:</label>
						<input type="number" class="form-control" v-model="cbtquestions[index].score" required="required" />
					</div>
				</div>
				<!-- END QUESTION TYPE SINGLE ANSWER -->

				<!-- QUESTION TYPE: MULTIPLE ANSWER AND ORDERED ANSWERS -->
				<div v-else-if="question.questiontype == 'ma' || question.questiontype == 'oa'" class="single_question">
					<div class="form-group">
						<h6 class="mb-2">Question {{index + 1}}: </h6>
						<textarea v-model="cbtquestions[index].questioncontent" placeholder="Question" class="form-control" required="required"></textarea>
					</div>
					<div class="form-group question_options">
						<label>Question Options:</label>
						<div class="row">
							<div class="col-lg-6 mt-2" v-for="(options, option_index) in question.options">
								<input type="text" v-model="cbtquestions[index].options[option_index]" class="form-control" v-bind:placeholder="'Option ' + (option_index + 1)"
								 required="required" />
							</div>
							<div class="col-lg-6">
								<button type="button" class="btn btn-inverse btn-outline-inverse btn-sm mt-2" v-on:click="removeFieldFromQuestion('options', index)"
								 v-if="question.options.length > 0">
									<i class="icofont icofont-minus"></i>
								</button>
								<button type="button" class="btn btn-inverse btn-outline-inverse btn-sm mt-2" v-on:click="addFieldToQuestion('options', index)">
									<i class="icofont icofont-plus"></i>
								</button>
							</div>
						</div>
					</div>
					<div class="form-group question_answer" v-if="cbtquestions[index].options.length > 1">
						<label v-if="question.questiontype == 'ma'">Correct Answers:</label>
						<label v-else>Check the answers in the right order:</label>
						<div v-for="(options, o_index) in question.options">
							<input type="checkbox" v-bind:name="'question_option_' + index" v-bind:value="o_index" v-model="cbtquestions[index].answers" />
							<span class="ml-2">{{cbtquestions[index].options[o_index]}}</span>
						</div>
						<div v-if="cbtquestions[index].answers.length > 1 && question.questiontype == 'oa'">
							<label class="mt-2"><b>Correct Answer Order:</b></label>
							<span v-for="(i, i_index) in cbtquestions[index].answers">
								{{cbtquestions[index].options[i]}}
								<span v-if="i_index !== cbtquestions[index].answers.length - 1">
									>
								</span>
							</span>
						</div>
					</div>
					<div class="form-group score mt-3">
						<label>Question Score:</label>
						<input type="number" class="form-control" v-model="cbtquestions[index].score" required="required" />
					</div>
				</div>
				<!-- END QUESTION TYPE MULTIPLE ANSWER AND ORDERED ANSWERS -->

				<!-- QUESTION TYPE: SHORT TEXT (FILL IN THE BLANK) -->
				<div v-else-if="question.questiontype == 'st'" class="single_question">
					<div class="form-group">
						<h6 class="mb-2">Question {{index + 1}}: </h6>
						<textarea v-model="cbtquestions[index].questioncontent" placeholder="Use underscores to represent blanks. Example: A ______ is the name of a person."
						 class="form-control" required="required"></textarea>
					</div>
					<div class="form-group">
						<label>Number of blanks in question: </label>
						<input type="number" v-model.number="question.inputs" v-on:input="createAnswerFields(index)" class="form-control" />
					</div>
					<div class="form-group" v-if="question.inputs > 0">
						<label>Answer for blanks: </label>
						<div class="row">
							<div class="col-lg-6 mt-2" v-for="(input, input_index) in question.inputs">
								<input type="text" class="form-control" v-model="cbtquestions[index].answers[input_index]" v-bind:placeholder="'Answer to blank ' + (input_index + 1)"
								 required="required" />
							</div>
						</div>
					</div>
					<div class="form-group score mt-3">
						<label>Question Score:</label>
						<input type="number" class="form-control" v-model="cbtquestions[index].score" required="required" />
					</div>
				</div>
				<!-- END QUESTION TYPE SHORT TEXT (FILL IN THE BLANK) -->

				<!-- QUESTION TYPE: LONG TEXT -->
				<div v-else class="single_question">
					<div class="form-group">
						<h6 class="mb-2">Question {{index + 1}}: </h6>
						<textarea v-model="cbtquestions[index].questioncontent" placeholder="Question" class="form-control" required="required"></textarea>
					</div>
					<div class="form-group score mt-3">
						<label>Maximum Possible Score:</label>
						<input type="number" class="form-control" v-model="cbtquestions[index].score" required="required" />
					</div>
				</div>
				<!-- END QUESTION TYPE LONG TEXT (FILL IN THE BLANK) -->
			</div>

			<div v-if="$checkPerm('process.cbt.add_questions')" class="row mt-5">
				<div class="col-lg-6">
					<label>Add Question:</label>
					<select class="form-control" required="required" v-model="questiontype">
						<option value="sj">Situational Judgement</option>
						<option value="sa">Single Answer</option>
						<option value="ma">Multiple Answer</option>
						<option value="oa">Ordered Answer</option>
						<option value="st">Short Text (e.g: Fill in the blank)</option>
						<option value="lt">Long Text (e.g: Explanation)</option>
					</select>
				</div>
				<div class="col-lg-2">
					<label>&nbsp;</label><br>
					<button class="btn btn-inverse btn-outline-inverse btn-sm" type="button" v-on:click="addNewQuestion">
						<i class="icofont icofont-plus"></i>
					</button>
				</div>
			</div>

			<div class="form-group mt-4">
				<input type="submit" class="btn btn-primary btn-md" value="Submit" />
			</div>

		</form>

	</div>
</template>
<style scoped="">
	ul{
		list-style: none;
	}
	.question-text{
		height: 100px;
	}
	.single_question{
		border: 1px solid #ccc;
		padding: 20px;
		border-radius: 5px;
		margin-top: 20px;
	}
	.form-group label{
		font-weight: bolder;
	}
</style>
<script type="text/javascript">
	export default {
		props: {
			id: {
				required: true,
				type: Number
			}
		},
		name: 'AddCbtQuestion',
		data() {
			return {
				questiontype: 'sj',
				cbt: {
					cbt_id: this.id,
					company_id: this.$store.getters.user_data.data.company_id
				},
				cbtquestions: []
			}
		},
		methods: {
			getQuestionFormat: function (questiontype) {
		    	/*
					This methods returns the JSON format of the question type specified.
					The question types:
						sj - Situational Judgement
						sa - Single Answer
						ma - Multiple Answer
						oa - Ordered Answer
						st - Short Text Input
						lt - Long Text Input
		    	*/
				switch (questiontype) {
					case 'sj':
						return {
							"questiontype": "sj",
							"questioncontent": "",
							"options": [],
							"answer_tags": [],
							"score": "",
							"answers": []
						}
						break
					case 'sa':
						return {
							"questiontype": "sa",
							"questioncontent": "",
							"options": [],
							"score": "",
							"answers": [""]
						}
						break
					case 'ma':
					case 'oa':
						return {
							"questiontype": questiontype,
							"questioncontent": "",
							"options": [],
							"score": "",
							"answers": []
						}
						break
					case 'st':
						return {
							"questiontype": "st",
							"questioncontent": "",
							"inputs": "",
							"score": "",
							"answers": []
						}
						break
					case 'lt':
						return {
							"questiontype": "lt",
							"questioncontent": "",
							"score": ""
						}
						break
					default:
						// statements_def
						break
				}
			},

			addNewQuestion: function () {
				//The selected question type
				let selected_qt = this.questiontype

				//Get the question format
				let q_fmt = this.getQuestionFormat(selected_qt)

				//Append the format to the cbt questions array
				this.cbtquestions.push(q_fmt)

				console.log(this.cbtquestions)
			},

			addFieldToQuestion: function (field, index) {
		    	/*
		    		This functions appends an empty string to the a specified array (specified by "field")
		    		of a cbt question specified by "index"
		    	*/
				this.cbtquestions[index][field].push("")

		    	/*
		    		We need to create an index for the answers relative to the answer tags.
		    		We do [the following code] because we want to "v-model" the answers (from the dropdown)
		    		to an index of the "answers" array; this index does not exist so vue will throw an error.
		    	*/

				if (field == 'answer_tags') {
					this.cbtquestions[index].answers.push("")
				}
			},

			removeFieldFromQuestion: function (field, index) {
		    	/*
		    		This functions removes the last element of a specified array (specified by "field")
		    		of a cbt question specified by "index"
		    	*/
				this.cbtquestions[index][field].pop()
			},

			removeQuestion: function (index) {
				//Removes question at the specified index from the cbtquestions array

				var c = confirm("Remove question? This action cannot be undone.")

				if (c) {
					this.cbtquestions.splice(index, 1)
				}
			},

			createAnswerFields: function (index) {
		    	/*
		    		This function is specifically for the "Short Text" kind of question
					We insert blank fields into the answer array (creating indexes) to 
					match the number of blank fields.
		    	*/
				let this_question = this.cbtquestions[index]
				//Make the array blank
				this_question.answers = []

				if (this_question.inputs > 0) {
					for (var i = 0; i < this_question.inputs; i++) {
						this_question.answers[i] = ""
					}
				}
			},

			createQuestions: function () {

				this.cbt.cbt_questions = this.cbtquestions

				let request = {
					what: 'AddQuestionToCbt',
					data: this.cbt
				}

				console.log(this.cbt)

				this.$socket.makePostRequest(request)
					.then((response) => {
						if (response.type == 'AddQuestionToCbt') {
							//this.getCbt()
							this.$swal.fire('Success', "Questions added.", 'success')
						}
					})
					.catch((error) => {
						console.log(error)
					})
			},

			getCbt: function () {

				var cbt = {
					what: "ListCBT",
					params: {
						companyid: this.$store.getters.user_data.data.company_id
					}
				}

				this.$socket.makeGetRequest(cbt)
					.then((response) => {
						if (response.type == 'ListCBT') {
							var a = this.sortCbtById(response.data, this.id)
							this.cbtquestions = (a["cbtquestions"])
						}
					})
					.catch((error) => {
						console.log(error)
					})
			},

			sortCbtById: function (cbt_array, id) {

				let arr_count = cbt_array.length
				let cbt = []

				for (var i = 0; i < arr_count; i++) {
					if (cbt_array[i].id == id) {
						cbt = cbt_array[i]
						break
					}
				}

				return cbt
			}
		},

		mounted() {
			this.getCbt()
		}
	}
</script>